export const footballPromoContent = {
    es: {
        badge: 'LaLiga · UEFA Champions League · Liguee1',
        titleLine1: 'Lo mejor del fútbol europeo',
        titleAccent: 'en directo y en 4K',
        body: 'LaLiga, la Champions League y todos los grandes clubes europeos, cada semana, sin cortes, en todos tus dispositivos.',
        features: ['Todos los clubes', 'Todos los dispositivos', 'Activación en 1 min'],
        cta: 'Pedir ahora',
        security: 'Soporte 24/7 · Pago 100% seguro',
        offerExpires: 'La oferta termina en',
        hours: 'Horas',
        minutes: 'Min',
        seconds: 'Seg',
        leagueLogoAlt: 'La Liga',
    },
};
